import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import InfoIcon from './InfoIcon';
import { ComplianceType } from './types';

interface BoldBodyInfoCardProps {
    title: string;
    body: string;
    monthlyCredit?: string;
    info?: boolean;
    complianceType: ComplianceType;
}

const BoldBodyInfoCard: React.FC<BoldBodyInfoCardProps> = ({ title, body, info, monthlyCredit, complianceType }) => (
    <Stack
        gap={'2'}
        justifyContent={'spaceBetween'}
        direction={'column'}
        maxWidth={'160px'}
        width={'50%'}
        minWidth={{ default: '130px', sm: 'unset' }}
    >
        <Stack direction={'row'} gap={'1'} alignItems={'center'} borderBottomWidth={0}>
            <Text color={'bodySecondary'} size={'b_xs'} whiteSpace={'nowrap'}>
                {title}
            </Text>
            {info && <InfoIcon monthlyCredit={monthlyCredit} complianceType={complianceType} />}
        </Stack>
        <Text fontWeight={'semibold'} size={'b_md'} overflow={'hidden'} textOverflow={'ellipsis'}>
            {body}
        </Text>
    </Stack>
);

export default BoldBodyInfoCard;
